export const data_module = {
    modulo: "payments-transactions",
}